import styled from "styled-components";
import ReactToPrint from "react-to-print";
import clsx from "clsx";
import { useLocale } from "hooks";

function PrinterCMP({ className, componentRef, trigger, title }) {
  const { isFA, isRTL } = useLocale();
  const renderedTitle = title || isFA ? "چاپ" : "Print";
  return (
    <ReactToPrint
      trigger={() =>
        trigger ?? (
          <button
            className={clsx(
              "tw-text-white tw-font-medium tw-bg-[#004983] tw-py-4 tw-px-6 tw-flex tw-items-center tw-cursor-pointer tw-group tw-text-sm tw-border-0",
              className
            )}
          >
            {renderedTitle}
          </button>
        )
      }
      content={() => componentRef.current}
    />
  );
}

const Printer = styled(PrinterCMP)`
  @media print {
    display: none;
  }
`;

export default Printer;
